import { Button, TextField } from "@rhema/ui";
import { type FormEvent, useState } from "react";
import { normaliseOrigin } from "./native";
import type { Platform } from "./types";

/** Lets desktop and mobile point at a self-hosted Rhema server. Shown on the own-server page. */
export function ServerSetting({ platform }: { platform: Platform }) {
  const current = platform.serverOrigin();
  const isDefault = current === platform.defaultServerOrigin;
  const [value, setValue] = useState(isDefault ? "" : current);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const save = async (next: string | null) => {
    setError(null);
    setBusy(true);
    try {
      await platform.setServerOrigin(next);
    } catch (e) {
      setError(e instanceof Error ? e.message : "That server address did not work.");
      setBusy(false);
    }
  };

  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (!normaliseOrigin(value)) {
      setError("Enter a server address that starts with https://");
      return;
    }
    void save(value);
  };

  return (
    <form onSubmit={submit} className="flex flex-col gap-3">
      <p className="m-0 text-sm text-ink-secondary">This app uses {current}.</p>
      <TextField
        label="Server address"
        hint="Changing the server signs you out on this device."
        error={error}
        type="url"
        inputMode="url"
        autoCapitalize="off"
        autoCorrect="off"
        spellCheck={false}
        placeholder="https://rhema.example.org"
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <Button type="submit" size="lg" disabled={busy}>
        {busy ? "Connecting" : "Connect"}
      </Button>
      {!isDefault && (
        <Button variant="ghost" disabled={busy} onClick={() => void save(null)}>
          Use the Rhema server
        </Button>
      )}
    </form>
  );
}
